const defaultTheme = require("tailwindcss/defaultTheme");

export const MAX_ANONYMOUS_PROMPTS_ALLOWED = 0;
export const DESKTOP_BREAKPOINT = Number.parseInt(defaultTheme.screens.md);
export const INTERCOM_ACTION_COLOR = "#F55036";
export const INTERCOM_BACKGROUD_COLOR = "#FFFFFF";
